import { useContext } from 'react';

import type { EditContextType } from '../../context/edit-context/edit-context';
import { EditContext } from '../../context/edit-context/edit-context';

export const useEditContext = (): EditContextType => {
  const context = useContext(EditContext);

  if (!context) {
    throw new Error('No host Provider found. Please setup the EditContext');
  }

  return context;
};
